import { LATEST_SEARCH_LOCAL_STORAGE } from '../constants'

export default async () => {
  localStorage.removeItem(LATEST_SEARCH_LOCAL_STORAGE)
  return []
}
